<template>
<v-card
  class="mx-auto elevation-20 pb-0 mb-0"
  style='min-height:800px;' >
  <v-dialog fullscreen transition="dialog-bottom-transition"
    v-if='navDrawerIsVisible'
    v-model='showNavDrawer'
    :width='450' >
    <v-system-bar status
      v-if="appPlatform === 'ios'"
      class='header-toolbar'
      :class="themeColor">
    </v-system-bar>
    <home-detail
      @close='showNavDrawer=false'
      :homepage='schedule'
      :appointment='appointment'
      :loading='loading' >
    </home-detail>
  </v-dialog>

  <v-progress-linear
    v-if='loading'
    indeterminate height='3' class='ma-0' >
  </v-progress-linear>

  <v-card
    v-touch="{left: () => { $emit('next') }, right: () => { $emit('previous') }}"
    dark flat >
    <v-img v-if='!showDatepicker' :src="backgroundImg"
      height="180px"
      gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)" >
      <v-layout>
        <v-btn
          @click.stop='showDatepicker=true'
          class='mt-4' fab small absolute top right >
          <v-icon>event</v-icon>
        </v-btn>
        <v-flex xs11>
          <h3 class="title font-weight-light mt-3 ml-3 grow">
            {{greeting}} {{this.me.first_name}}
          </h3>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-layout align-center>
        <strong class="display-4 font-weight-regular mr-4 ml-5"
          @click="showDatepicker=true" >
          {{ dateformat(date, 'D') }}
        </strong>
        <v-layout column justify-end>
          <v-btn @click="$emit('previous:week')" icon absolute left style='left:0px;top:80px' >
            <v-icon dark >chevron_left</v-icon>
          </v-btn >
          <v-btn @click="$emit('next:week')" icon absolute right style='top:80px' >
            <v-icon dark >chevron_right</v-icon>
          </v-btn >
          <div class="headline font-weight-light">
            {{ dateformat(date, 'ddd') }}
          </div>
          <div class="text-uppercase font-weight-light">{{ dateformat(date, 'MMMM YYYY')}}</div>
          <div>&nbsp;</div>

        </v-layout>
      </v-layout>
    </v-img>
    <v-img v-else class='text-xs-center' >
      <v-btn
          @click.stop='showDatepicker=false'
          class='mt-4' fab small absolute top right >
          <v-icon>close</v-icon>
      </v-btn>
      <v-date-picker
        v-model='localDate'
        dark flat full-width no-title class='elevation-0 pt-4 mt-4' >
      </v-date-picker>
      <v-btn v-if='!isToday' @click='settoday' small outlined outline >Today</v-btn>
      <v-btn to='/calendar' block small outlined outline >Go to calendar</v-btn>
    </v-img>
  </v-card>
  <!-- <v-toolbar flat dense ></v-toolbar> -->
  <v-slider ticks
      v-model="debouncedDay" :max="6"
      @change='dowChanged'
      :tick-labels="dow"
      class="mx-0 px-3 mt-0 grey lighten-5" >
    </v-slider>
  <v-divider></v-divider>
  <v-card-text
    v-touch="{ left: () => { $emit('next') }, right: () => { $emit('previous') } }"
    class="pa-0">
    <transition name='fade' mode='out-in' >
      <v-card-text v-if='firstload && loading' class='text-xs-center my-5'>
        <v-progress-circular indeterminate color=amber width='2' size='70' >
        </v-progress-circular>
      </v-card-text>
      <v-timeline v-else align-top dense class='ml-0' >
        <v-timeline-item class='mt-3 pr-2' >
          {{welcomeNote}}
        </v-timeline-item>
        <v-divider />
        <v-subheader class='overline pr-1 my-0 pl-5 bold--text grey lighten-4' >
          Schedule
          <v-spacer/>
          <v-btn small outline
            @click="newAppointmentClicked"
            color='primary' ><v-icon small class='mr-1' >event</v-icon> New</v-btn>
          <!-- <v-btn fab absolute right small dark
            color='pink' class='mr-1'
            @click="newAppointmentClicked">
            <v-icon>add</v-icon>
          </v-btn> -->
        </v-subheader>
        <v-timeline-item small
          v-for='appt in appointments'
          :key='appt.id'
          :color="getColor(appt)"
          :class='getActiveColor(appt)' >
          <template slot='icon'>
            <v-avatar
              @click.stop='iconClicked(appt)'
              class='pl-2' ></v-avatar>
          </template>
          <v-layout
            @click='itemClicked(appt)' pt-3>
            <v-flex xs2>
              <strong>{{dateformat(appt.start_time, 'HH:mm')}}</strong>
              <div><small>- {{dateformat(appt.end_time, 'HH:mm')}}</small></div>
              <!-- <v-chip dark
                v-if='formatStatus(appt.status) && formatStatus(appt.status).title'
                :color='formatStatus(appt.status).theme'
                class='pl-0 v-chip--x-small label' >{{ formatStatus(appt.status).title }}</v-chip> -->
            </v-flex>
            <v-flex xs9>
              <strong>{{appt.title || appt.full_name}}</strong>
              <div v-if='appt.product_name' class="caption" >
                {{ appt.product_name }}
                <span v-if="appt.address_name" >
                  @ {{ appt.address_name }}
                </span>
              </div>
              <template v-if="appt.tags && appt.tags.length > 0">
                <v-chip label outline v-for="tag in appt.tags" :key="tag" class="v-chip--x-small" >
                  {{tag}}
                </v-chip>
              </template>  

            </v-flex >
            <v-flex v-if='withAction' class='text-xs-right' >
              <!-- <v-btn @click='$emit("selected", appointment)' icon > -->
              <v-btn icon >
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-timeline-item>

        <v-timeline-item fill-dot color='white' v-if='appointments.length < 1' >
          <template slot='icon'>
            <v-avatar
              @click.stop='iconClicked(appointment)'
              class='pl-2' ></v-avatar>
          </template>
          <v-layout class='pt-3'>
            <span >No appointments scheduled yet.</span>
          </v-layout>
        </v-timeline-item>

        <v-timeline-item fill-dot color='white' >
          <template slot='icon'>
              <v-avatar class='pl-2' > 🎉</v-avatar>
          </template>
          <v-layout class='pt-3'>
            <span >{{ $t('messages.endofday') }}</span>
          </v-layout>
        </v-timeline-item>
      </v-timeline>
    </transition>
  </v-card-text>
  <v-divider></v-divider>
  <v-footer class='mb-0' absolute bottom >
    <v-btn @click='$emit("previous")' icon >
      <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn @click='showDatepicker=!showDatepicker' flat text >
      {{ dateformat(date) }}
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn @click='$emit("next")' icon >
      <v-icon>chevron_right</v-icon>
    </v-btn>
  </v-footer>

  <appointment-bottom-sheet
    v-if='selectedAppointment'
    v-model='showBottomSheet'
    :appointment='selectedAppointment' >
  </appointment-bottom-sheet>
</v-card>
</template>

<script>
import moment from 'moment'
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import AppointmentBottomSheet from '@/components/appointment/actions/AppointmentBottomSheet'
import HomeDetail from '@/components/home/Detail'
import {BACKGROUNDS} from '@/components/home/backgrounds'

export default {
  name: 'ScheduleTimeline',
  components: { HomeDetail, AppointmentListItem, AppointmentBottomSheet },
  props: {
    schedule: { type: Object, default: () => { return {} } },
    appointment: { type: Object, default: () => { return {} } },
    withAction: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    date: { type: String }
  },
  data () {
    return {
      firstload: true,
      showNavDrawer: false,
      showDatepicker: false,
      showBottomSheet: false,
      activeClient: null,
      localDate: null,
      selectedAppointment: null,
      debouncedDay: null,
      timeout: null,
      dow: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    }
  },
  mounted () {
    this.localDate = this.date
    this.debouncedDay = moment(this.date).day()
  },
  watch: {
    localDate () {
      this.$vuetify.goTo(0)
      this.$emit('date', this.localDate)
      this.showDatepicker = false
    },
    date () {
      if (this.date) {
        this.localDate = this.date
        this.debouncedDay = moment(this.date).day()
      }
    },
    loading () {
      if (this.loading === false) {
        this.firstload = false
      }
    }
  },
  computed: {
    appointments () {
      if (this.schedule && this.schedule.schedule) {
        return this.schedule.schedule
      }
      return []
    },
    backgroundImg () {
      let images = BACKGROUNDS[this.timeOfDay]
      let index = Math.floor(Math.random() * images.length)
      return images[index]
    },
    navDrawerIsVisible () {
      /* if we should hide it completely or just offscreen is ok */
      // always visible for mobile:
      if (this.$vuetify.breakpoint.xs) {
        return true
      }
      return this.showNavDrawer
    },
    isToday () {
      let today = moment().format('YYYY-MM-DD')
      return today === this.date
    },
    todaysClients () {
      let clients = []
      this.appointments.filter((appt) => {
        if (appt.status === 'B') { return false }
        let isNew = clients.indexOf(appt.client) === -1
        if (isNew) { clients.push(appt.client) }
        return isNew
      }, [])
      return clients
    },
    timeOfDay () {
      let now = moment()
      let currentHour = now.hour()
      if (currentHour >= 12 && currentHour <= 17) return 'afternoon'
      else if (currentHour >= 18) return 'evening'
      else return 'morning'
    },
    greeting () {
      let greetings = {
        morning: 'Good morning',
        afternoon: 'Good afternoon',
        evening: 'Good evening'
      }
      return greetings[this.timeOfDay]
    },
    welcomeNote () {
      let note = ''
      if (this.appointments && this.appointments.length > 0) {
        let first = this.dateformat(this.appointments[0].start_time, 'HH:mm a')
        let lastAppt = this.appointments[this.appointments.length - 1]
        let last = this.dateformat(lastAppt.end_time, 'HH:mm a')
        if (this.todaysClients.length === 1) {
          note += `${this.todaysClients.length} client ${this.relativeDate}. `
        } else if (this.todaysClients.length === 0) {
          note += `No clients ${this.relativeDate}. `
        } else {
          note += `${this.todaysClients.length} clients ${this.relativeDate}. `
        }
        if (this.appointments.length === 1) {
          note += `Your first appointment is at ${first}`
        } else {
          note += `Your first appointment is at ${first} and your last appointment ends at ${last}`
        }
      }
      return note
    },
    relativeDate () {
      return moment(this.date).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'on dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'DD/MM/YYYY'
      })
    }
  },
  methods: {
    settoday () {
      this.localDate = moment().format('YYYY-MM-DD')
    },
    dowChanged () {
      let initialDow = moment(this.date).day()
      let diff = this.debouncedDay - initialDow
      console.log(initialDow, diff, this.localDate)
      this.localDate = moment(this.localDate).add(diff, 'days').format('YYYY-MM-DD')
    },
    getColor (appointment) {
      if (appointment && appointment.id) {
        let status = this.formatStatus(appointment.status)
        if (status && status.theme) { return status.theme }
        if (this.appointment && this.appointment.id === appointment.id) {
          return 'pink'
        }
      }
      return 'teal lighten-3'
    },
    getActiveColor (appointment) {
      if (this.appointment && this.appointment.id === appointment.id) {
        return 'grey lighten-3 active-timeline-item'
      }
      return ''
    },
    product (appointment) {
      if (appointment && appointment.product) {
        let product = appointment.product
        if (isNaN(product)) {
          return product
        } else {
          return this.getProductById(product, true)
        }
      }
      return false
    },
    newAppointmentClicked () {
      let vm = this
      setTimeout(() => {
        let startTime = this.localDate + ' 08:00'
        vm.$store.commit('SET_SETTING', ['startTime', startTime])
      }, 1000)
      this.openGlobalDialog(true, 'QuickCreate')
    },
    iconClicked (appointment) {
      this.showBottomSheet = false
      this.selectedAppointment = appointment
      window.setTimeout(() => {
        this.showBottomSheet = true
      }, 10)
      console.log('icon clicked!!')
    },
    itemClicked (appointment) {
      if (this.$vuetify.breakpoint.xs) {
        let activeClientId = null
        if (this.activeClient) {
          activeClientId = this.activeClient.id
        }
        if (appointment.client !== activeClientId) {
          this.activeClient = this.$store.getters.clients.find((client) => {
            if (client && client.client && client.client.id && appointment && appointment.client) {
              // console.log(client.client, appointment.client)
              return (client.client.id.toString() === appointment.client.toString())
            }
          })
        }
        this.showNavDrawer = true
      }
      this.$emit('selected', appointment)
    }
  },
  i18n: {
    messages: {
      en: {
        messages: {
          endofday: 'Home time!'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Schedule.vue?793b1e50